<template>
  <div id="kt_header" style="" class="header align-items-stretch">
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
      <div class="d-flex align-items-center d-lg-none ms-n1 me-2" title="Show aside menu">
        <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_aside_mobile_toggle">
          <i class="ki-outline ki-abstract-14 fs-1"></i>
        </div>
      </div>
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <router-link :to="{name: 'Index'}" class="d-lg-none">
          <img alt="Logo" :src="require('@/assets/media/logos/demo6.svg')" class="h-25px" />
        </router-link>
      </div>
      <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
        <div class="d-flex align-items-stretch" id="kt_header_nav">
          <div class="header-menu align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_header_menu_mobile_toggle" data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}">
            <div class="menu menu-rounded menu-column menu-lg-row menu-active-bg menu-state-primary menu-title-gray-700 menu-arrow-gray-500 fw-semibold my-5 my-lg-0 px-2 px-lg-0 align-items-stretch" id="#kt_header_menu" data-kt-menu="true">
              <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                <span class="menu-link py-3">
                  <span class="menu-title">Помощь</span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown px-lg-2 py-lg-4 w-lg-200px">
                  <div class="menu-item">
                    <a href="https://safety.energocharge.uz/" target="_blank" class="menu-link py-3">
                      <span class="menu-title">Тех. безопасности</span>
                    </a>
                  </div>
                  <div class="menu-item">
                    <a href="https://guide.energocharge.uz/" target="_blank" class="menu-link py-3">
                      <span class="menu-title">Инструкция</span>
                    </a>
                  </div>
                  <div class="menu-item">
                    <a href="https://faq.energocharge.uz/" target="_blank" class="menu-link py-3">
                      <span class="menu-title">FAQ</span>
                    </a>
                  </div>
                </div>
              </div>
              <div data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start" class="menu-item menu-lg-down-accordion menu-sub-lg-down-indention me-0 me-lg-2">
                <span class="menu-link py-3">
                  <span class="menu-title">О Нас</span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
                <div class="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown px-lg-2 py-lg-4 w-lg-200px">
                  <div class="menu-item">
                    <a href="https://agreement.energocharge.uz/" target="_blank" class="menu-link py-3">
                      <span class="menu-title">Пользовательское соглашение</span>
                    </a>
                  </div>
                  <div class="menu-item">
                    <a href="https://politics.energocharge.uz/" target="_blank" class="menu-link py-3">
                      <span class="menu-title">Политика</span>
                    </a>
                  </div>
                  <div class="menu-item">
                    <a href="#" target="_blank" class="menu-link py-3">
                      <span class="menu-title">Социальные сети</span>
                    </a>
                  </div>
                </div>
              </div>
              <div @click="showComplaintsModal" class="menu-item menu-here-bg menu-lg-down-accordion me-0 me-lg-2">
                <span class="menu-link py-3">
                  <span class="menu-title">Создать обращение</span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </div>
              <div @click="openIssuerProfileModal" class="menu-item menu-here-bg menu-lg-down-accordion me-0 me-lg-2">
                <span class="menu-link py-3">
                  <span class="menu-title">Поиск пользователя</span>
                  <span class="menu-arrow d-lg-none"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-stretch flex-shrink-0">
          <div class="d-flex align-items-center ms-1 ms-lg-3">
            <a href="#" class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px" data-kt-menu-trigger="{default:'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <i class="ki-outline ki-night-day theme-light-show fs-1"></i>
              <i class="ki-outline ki-moon theme-dark-show fs-1"></i>
            </a>
            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px" data-kt-menu="true" data-kt-element="theme-mode-menu">
              <div class="menu-item px-3 my-0">
                <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="light">
                  <span class="menu-icon" data-kt-element="icon">
                    <i class="ki-outline ki-night-day fs-2"></i>
                  </span>
                  <span class="menu-title">Светлый</span>
                </a>
              </div>
              <div class="menu-item px-3 my-0">
                <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="dark">
                  <span class="menu-icon" data-kt-element="icon">
                    <i class="ki-outline ki-moon fs-2"></i>
                  </span>
                  <span class="menu-title">Темный</span>
                </a>
              </div>
              <div class="menu-item px-3 my-0">
                <a href="#" class="menu-link px-3 py-2" data-kt-element="mode" data-kt-value="system">
                <span class="menu-icon" data-kt-element="icon">
                  <i class="ki-outline ki-screen fs-2"></i>
                </span>
                <span class="menu-title">Системный</span>
                </a>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center ms-1 ms-lg-3" id="kt_header_user_menu_toggle">
            <div class="cursor-pointer d-flex symbol symbol-30px symbol-md-40px" data-kt-menu-trigger="click" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <i class="ki-duotone ki-profile-circle fs-2x">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
            </div>
            <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px" data-kt-menu="true">
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <div class="symbol symbol-50px me-5">
                    <i class="ki-duotone ki-profile-circle fs-3x">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fw-bold d-flex align-items-center fs-5">{{ phone ?? 'Неизвестно' }}</div>
                  </div>
                </div>
              </div>
              <div class="separator my-2"></div>
              <div v-if="false" class="menu-item px-5">
                <span class="menu-link px-5">Профиль</span>
              </div>
              <div class="menu-item px-5">
                <span @click="logout" class="menu-link text-hover-danger px-5">Выйти</span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center d-lg-none ms-2 me-n2" title="Show header menu">
            <div class="btn btn-icon btn-active-color-primary w-30px h-30px w-md-40px h-md-40px" id="kt_header_menu_mobile_toggle">
              <i class="ki-outline ki-burger-menu-2 fs-1"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <complaints-modal v-if="showModal" @close="closeModal"/>
  <issuer-profile-modal v-if="showIssuerProfileModal" @close="closeIssuerProfileModal"/>
</template>

<script>
import ComplaintsModal from "@/components/Modals/ComplaintsModal.vue";
import IssuerProfileModal from "@/components/Modals/IssuerProfileModal.vue";

export default {
  name: 'VHeader',
  components: { ComplaintsModal, IssuerProfileModal },
  data() {
    return {
      phone: localStorage.getItem('phone'),
      showModal: false,
      showIssuerProfileModal: false,
    }
  },
  methods: {
    logout() {
      if (confirm('Вы уверены, что хотите выйти?')) {
        localStorage.removeItem('access');
        localStorage.removeItem('phone');
        window.location.reload();
      }
    },
    showComplaintsModal() {
      this.showModal = true
      setTimeout(() => { new bootstrap.Modal('#сomplaintsModal').show() }, 10)
    },
    closeModal(val) {
      this.showModal = !val
    },
    openIssuerProfileModal() {
      this.showIssuerProfileModal = true
      setTimeout(() => { new bootstrap.Modal('#issuerProfileModal').show() }, 10)
    },
    closeIssuerProfileModal(val) {
      this.showIssuerProfileModal = !val
    }
  }
}
</script>

<style scoped>

</style>